import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@independent-software/typeui/controls/Button';
import { Icon } from '@independent-software/typeui/controls/Icon';

import { AuthContext } from '../../AuthContext';
import { FilterContext } from '../../FilterContext';
import { Container, Content, BottomBar } from '../../modules';
import { Campaign } from '../../resource/';
import { ListCampaigns } from './ListCampaigns';
import { Gate } from '../../controls/Gate';

const CampaignList = () => {
  const auth = React.useContext(AuthContext);
  const filter = React.useContext(FilterContext);
  const navigate = useNavigate();

  // Go to add campaign view.
  const handleAdd = () => {
    navigate('/campaigns/add');
  }  

  // Go to view campaign view.
  const handleClick = (item: Campaign) => {
    navigate(`/campaigns/${item.id}`);
  }  

  return (
    <Container>
      <Content>
        <ListCampaigns auth={auth} filter={filter} name="campaigns" onClick={handleClick}/>
      </Content>
      <BottomBar>
        <Gate right='can_edit_campaigns'>
          <Button primary onClick={handleAdd}><Icon name="plus"/> Add campaign</Button>
        </Gate>
      </BottomBar>
    </Container>
  );
}

export { CampaignList }
